/**
 * Enum Trạng thái bản ghi sao lưu
 * nmtuan4 8.3.2023
 */
export default {
  Success: 1, // sao lưu thành công
  WaitingBackup: 2, // đang sao lưu
  Error: 3, // sao lưu thất bại
  Expiration: 4, // quá hạn
  // CancelBackup: 5, // đang bấm hủy sao lưu
  WaitingRestore: 6, // đang phục hồi
  // CancelRestore: 7, // đang bấm hủy phục hồi
};
